import {
  IDeleteOfferFromFavoritesResponseError,
  IDeleteOfferFromFavoritesResponse400,
} from '../../../../repositories/favorites/v1/delete-offer-from-favorites';

export const mapDeleteFavoriteResponseError = (
  response: IDeleteOfferFromFavoritesResponseError,
): IDeleteOfferFromFavoritesResponse400 => {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
